import { LatLngLiteral } from '@googlemaps/google-maps-services-js';
import { createFeature, createReducer, on } from '@ngrx/store';
import { UserServiceCreateResponseJson } from '@vmspdb/definitions';
import { PaginatedUserActions } from './paginated-user.actions';

export const paginatedUserFeatureKey = 'paginatedUser';

export interface PaginatedUserState {
  items: UserServiceCreateResponseJson[];
  loading: boolean;
  total: number;
  page: number;
  error: any;
  refGeoPoint: LatLngLiteral | undefined;
}

export const initialState: PaginatedUserState = {
  items: [],
  total: 0,
  page: 0,
  loading: false,
  error: undefined,
  refGeoPoint: undefined,
};

export const reducer = createReducer(
  initialState,
  on(PaginatedUserActions.listPaginatedUsers, (state): PaginatedUserState => ({
    ...state,
    loading: true,
  })),
  on(
    PaginatedUserActions.listPaginatedUsersSuccess,
    (state, { data }): PaginatedUserState => ({
      ...state,
      ...data,
      ...data.pagination,
      total: Number(data.pagination?.total),
      loading: false,
    }),
  ),
  on(
    PaginatedUserActions.listPaginatedUsersFailure,
    (state, { error }): PaginatedUserState => ({
      ...state,
      error,
      loading: false,
    }),
  ),
  on(
    PaginatedUserActions.setRefGeopoint,
    (state, { refGeoPoint }): PaginatedUserState => ({
      ...state,
      refGeoPoint,
    }),
  ),
);

export const paginatedUserFeature = createFeature({
  name: paginatedUserFeatureKey,
  reducer,
});
